import { supabase } from '@/integrations/supabase/client';

interface ReplaceAgentUserAssignmentsInput {
  agentId: string;
  assignToAll: boolean;
  userIds: string[];
  assignedByProfileId: string | null;
  useEnterpriseHierarchy: boolean;
}
export async function replaceAgentUserAssignments({
  agentId,
  assignToAll,
  userIds,
  assignedByProfileId,
  useEnterpriseHierarchy,
}: ReplaceAgentUserAssignmentsInput): Promise<number> {
  const uniqueUserIds = [...new Set(userIds.filter(Boolean))];

  if (!assignToAll && uniqueUserIds.length === 0) {
    throw new Error('Select at least one user for specific-user access.');
  }

  if (useEnterpriseHierarchy) {
    const { data, error } = await (supabase as any).rpc('replace_agent_user_assignments', {
      p_agent_id: agentId,
      p_assign_to_all: assignToAll,
      p_user_ids: uniqueUserIds,
    });

    if (error) throw error;
    return Number(data || 0);
  }

  const { error: deleteError } = await supabase
    .from('agent_assignments')
    .delete()
    .eq('agent_id', agentId);

  if (deleteError) throw deleteError;
  if (assignToAll) return 0;

  const { error: insertError } = await supabase
    .from('agent_assignments')
    .insert(uniqueUserIds.map((userId) => ({
      agent_id: agentId,
      user_id: userId,
      assigned_by: assignedByProfileId,
    })));

  if (insertError) throw insertError;
  return uniqueUserIds.length;
}
